import Vue from 'vue'
import router from '@/router'
import store from '@/store'

/**
 * 获取uuid
 */
export function getUUID () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth (key) {
  let authorities = JSON.parse(sessionStorage.getItem('authorities') || '[]')
  if (authorities.length) {
    for (const i in authorities) {
      const element = authorities[i]
      if (element === key) {
        return true
      }
    }
  }
  return false
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate (data, id = 'id', pid = 'parentId') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]['list']) {
        temp[data[k][pid]]['list'] = []
      }
      if (!temp[data[k][pid]]['_level']) {
        temp[data[k][pid]]['_level'] = 1
      }
      data[k]['_level'] = temp[data[k][pid]]._level + 1
      temp[data[k][pid]]['list'].push(data[k])
    } else {
      res.push(data[k])
    }
  }
  return res
}

/**
 * 将数组中的parentId列表取出，倒序排列
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function idList (data, val, id = 'id', children = 'children') {
  let res = []
  idListFromTree(data, val, res, id)
  return res
}

/**
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
function idListFromTree (data, val, res = [], id = 'id', children = 'children') {
  for (let i = 0; i < data.length; i++) {
    const element = data[i]
    if (element[children]) {
      if (idListFromTree(element[children], val, res, id, children)) {
        res.push(element[id])
        return true
      }
    }
    if (element[id] === val) {
      res.push(element[id])
      return true
    }
  }
}

/**
 * 清除登录信息
 */
export function clearLoginInfo () {
  Vue.cookie.delete('Authorization')
  // store.commit('resetStore')
  router.options.isAddDynamicMenuRoutes = false
}
/**
 * 获取当前时间
 * @param type 要获取的时间类型：date年-月-日/time时-分-秒/week星期几
 * @param t 要格式化的时间
 */
export function getCurrentTime (type, t) {
  const date = t ? new Date(t) : new Date()
  const y = date.getFullYear()
  const m = (date.getMonth() + 1).toString().padStart(2, '0')
  const d = date
    .getDate()
    .toString()
    .padStart(2, '0')
  const h = date
    .getHours()
    .toString()
    .padStart(2, '0')
  const min = date
    .getMinutes()
    .toString()
    .padStart(2, '0')
  const s = date
    .getSeconds()
    .toString()
    .padStart(2, '0')
  const weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  const week = weekArr[date.getDay()]
  let time = ''
  if (type === 'date') {
    time = `${y}年${m}月${d}日`
  } else if (type === 'week') {
    time = week
  } else if (type === 'time') {
    time = `${h}:${min}:${s}`
  } else {
    time = `${y}-${m}-${d} ${h}:${min}:${s}`
  }
  // const time = `${y}-${m}-${d} ${h}:${min}:${s}`
  return time
}

export function debounce (fn, wait = 500) {
  let timer = null
  return function (...args) {
    const _this = this
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(_this, ...args)
    }, wait)
  }
}

export function forbidSpaceEvent (e) {
  if (e && e.code === 'Space') {
    e.preventDefault()
  }
}

export function isValidPhoneNumber (phoneNumber) {
  return /^1[3-9]\d{9}$/.test(phoneNumber)
}
